import * as Yup from 'yup'



export const validationSchemas = () => {
   
  let validationObject = { };
  validationObject["fechaOcurrencia"] = Yup.date().required('La Fecha es obligatoria.');
  validationObject["comentario"] = Yup.string().required('Comentario es obligatorio.').test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  );
  return Yup.object().shape(validationObject);
}

